export function formatSalary(salary, round = true, showUnit = true)
{
    salary = parseInt(salary);
    const unit = showUnit ? ' €' : '';

    if (salary >= 1000) {
        salary = (round ? Math.round(salary / 1000) : (salary.toLocaleString()))
    }

    return salary + unit
}

export function formatPhone(e){
    const regex = /[^0-9+]/;
    return e.target.value.replace(regex, '');
}
